import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgPin(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.90103 17.8461C1.03296 13.9923 1.03299 7.74412 4.90111 3.89035C8.76925 0.0365498 15.0407 0.036551 18.9089 3.89035C22.777 7.74412 22.777 13.9923 18.909 17.8461L13.3194 23.4162C12.5383 24.1946 11.2717 24.1946 10.4906 23.4162L4.90103 17.8461ZM8.28 10.8383C8.28 8.84374 9.90297 7.22679 11.905 7.22679C13.907 7.22679 15.53 8.84374 15.53 10.8383C15.53 12.833 13.907 14.4499 11.905 14.4499C9.90297 14.4499 8.28 12.833 8.28 10.8383Z", fill: "currentColor" })));
}
export default SvgPin;
